import controller from './logout.controller';
/**
 * @ngdoc component
 * @name logout
 * @description
 * The logout component of the app.
 *
 * @memberof account
 */
export default {
  /**
   * The controller class for the component.
   * @type {LogoutController}
   */
  controller,
  /**
   * Component bindings
   * @type {Object}
   * @property {String} updated  If the logout reason is updated.
   */
  bindings: {
    updated: '@',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/logout/logout.component.js